import { render, staticRenderFns } from "./LoadsBySpecies.vue?vue&type=template&id=bbd60304&"
import script from "./LoadsBySpecies.vue?vue&type=script&lang=js&"
export * from "./LoadsBySpecies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports